// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PS2VAZ8NPQ8jKZuPm71G{flex-direction:column;flex:1;align-self:center;width:100%;max-width:760px;padding:0 16px;display:flex}.lubNW0thDr0qd87wX3y4{flex-direction:column;gap:4px;display:flex}.xQQdRroP91Ye_44fREGX{color:var(--content-primary-tertiary)}.hTxOdiXoBIg7hirEMW5f{height:inherit;flex-direction:column;flex-grow:1;display:flex}.DLA1ix4XRBQbkQE2oSRY{align-items:center;gap:10px;padding:16px 3px 12px;display:flex}.DLA1ix4XRBQbkQE2oSRY .idoXa8i556MMe9hmg6E0{flex:1}.DLA1ix4XRBQbkQE2oSRY .idoXa8i556MMe9hmg6E0>input{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:100%}.gJU6R_vnwi4J2AR2BDDK{min-width:109px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `PS2VAZ8NPQ8jKZuPm71G`,
	"header": `lubNW0thDr0qd87wX3y4`,
	"headerDescription": `xQQdRroP91Ye_44fREGX`,
	"wrap": `hTxOdiXoBIg7hirEMW5f`,
	"search": `DLA1ix4XRBQbkQE2oSRY`,
	"field": `idoXa8i556MMe9hmg6E0`,
	"guideButton": `gJU6R_vnwi4J2AR2BDDK`
};
export default ___CSS_LOADER_EXPORT___;
